export const stripDomain = (url: string) => {
  try {
    const { pathname } = new URL(url)
    return pathname.startsWith('/') ? pathname.slice(1) : pathname
  } catch {
    return url
  }
}
